(() => {
  const hideAppLink = () => {
    const link = document.querySelector('a[href="https://apps.shopify.com/eu-widerrufsbutton"]');
    if (link) {
      link.style.setProperty('display', 'none', 'important');
    }
  };

  hideAppLink();

  const observer = new MutationObserver(hideAppLink);
  observer.observe(document.body, { childList: true, subtree: true });
})();